import { isPushUiEnabled, onPushUiEnabled } from '@/push'

/**
 * Progressive-enhancement gate for push-only UI.
 * `pushUiEnabled` becomes true after the first successful WS/SSE connect
 * this session and resets on logout/disconnect. Old backends never connect,
 * so enhanced chips/indicators stay hidden.
 */
export const pushUiMixin = {
    data() {
        return {
            pushUiEnabled: isPushUiEnabled()
        }
    },
    created() {
        this._unsubPushUiEnabled = onPushUiEnabled(enabled => {
            this.pushUiEnabled = enabled
        })
    },
    beforeDestroy() {
        if (this._unsubPushUiEnabled) {
            this._unsubPushUiEnabled()
            this._unsubPushUiEnabled = null
        }
    }
}
